// Environment-aware logger.
// In production builds, errors are silenced to avoid leaking debug info in console.
// In development, errors log normally to help debugging.
//
// To wire up a real error reporting service later (Sentry, LogRocket, etc.),
// extend logger.error() to forward to that service in all environments.

const isDev = typeof process !== 'undefined'
  && process.env
  && process.env.NODE_ENV !== 'production';

export const logger = {
  error: (...args) => {
    if (isDev) {
      // eslint-disable-next-line no-console
      console.error(...args);
    }
    // TODO: forward to error reporting service in production (Sentry/etc.)
  },
  warn: (...args) => {
    if (isDev) {
      // eslint-disable-next-line no-console
      console.warn(...args);
    }
  },
  info: (...args) => {
    if (isDev) {
      // eslint-disable-next-line no-console
      console.info(...args);
    }
  },
  // Dev-only signal for *intentional, expected* failures (e.g. localStorage
  // blocked in private/incognito mode). Used inside try/catch guards where
  // the fallback is correct behavior — keeps the lint rule happy without
  // polluting production consoles.
  debug: (...args) => {
    if (isDev) {
      // eslint-disable-next-line no-console
      console.debug(...args);
    }
  },
};
